import EmployeeDashboardContainer from './EmployeeDashboardContainer';

export default EmployeeDashboardContainer;